import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Trash01Icon} from '@/components/ui/icon/Icon'
import {MedicalDevicesFormSchema, ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {projectMedicalDeviceToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'

interface ProjectMedicalDevicesFieldsProps {
    index: number
    disabledDevices: NonNullable<ProjectFieldsSchema['devices'][number]>['device'][]
    showTrashButton: boolean
    remove: (index: number) => void
}

export const ProjectMedicalDevicesFields = ({
    index,
    disabledDevices,
    showTrashButton,
    remove
}: ProjectMedicalDevicesFieldsProps) => {
    const {t} = useTranslation()
    const {control} = useFormContext<MedicalDevicesFormSchema>()
    const {field} = useController({control, name: `devices.${index}`})

    const handleChange = (value: string) => {
        field.onChange({
            device: value
        })
    }

    return (
        <Flexbox fullWidth justify="space-between" gap={1} align="flex-end">
            <InputSelect
                label={t('projects:medical_device_number', {number: index + 1})}
                placeholder={t('projects:medical_device_number_placeholder')}
                value={field.value.device}
                onChange={handleChange}
                optionsMap={projectMedicalDeviceToLabel}
                disabledOptions={disabledDevices}
            />
            {showTrashButton && (
                <Button variant="ghost" shape="square" onClick={() => remove(index)}>
                    <Trash01Icon />
                </Button>
            )}
        </Flexbox>
    )
}
